/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('reprintCtrl', reprintCtrl);

    reprintCtrl.$inject = ['tabs','datePickerService',
        'linkService','printService','reprintService','$stateParams','paginationService','messageService'];

    function reprintCtrl(tabs,datePickerService, linkService,printService,
                         reprintService,$stateParams,paginationService,messageService) {
        var vm = this;
        vm.tabs = tabs;
        vm.pages = paginationService.getPages();
        vm.isReport = false;
        vm.reportClassAvailabilityHtml = '';
        vm.code = $stateParams.code;
        loadAll();

        /*vm.generate = function (isValid) {
            if(isValid) {
                levelOfSaleReservationsService.getLevelOfSaleReservationByFlight(vm.filterLevelOfSalesReservations.flight.flightId)
                    .then(function (response) {
                        vm.reportClassAvailabilityHtml = response.data;
                        vm.isReport = true;
                    });
            }
        }

        vm.generatePdfHtml = function () {
            printService.printPdfHtml("reportClassAvailabilityHtml");
        }*/

        vm.generatePdf = function (index) {
            reprintService.getETicketById(linkService.getLinkId(vm.invoices[index]._links.self.href))
                .then(function (response) {
                    vm.invoiceHtml = response.ticket;
                    if(vm.invoiceHtml != undefined){
                        setTimeout(function(){
                            printService.print('invoiceHtml');
                            linkService.reloadRoute('reprint');
                        },300);
                    }
                });
        }

        function loadAll(){
            if($stateParams.code != ""){
                reprintService.getSearchWithoutTicketByPnr($stateParams.code, $stateParams.page, $stateParams.size)
                    .then(function (response) {
                        vm.invoices = (response.data._embedded) ? response.data._embedded.eTickets : [];
                        vm.pages = response.data.page;
                        if(vm.invoices.length > 0){
                            angular.forEach(vm.invoices, function(invoice){
                                invoice.codeOperation = getOperation(invoice.codeOperation);
                            });
                            vm.showPages = true;
                        }else{
                            messageService.registerDeleteGeneralError('reprint','air.reprint.thereIsNoInformation');
                        }
                    });
            }
        }

        function getOperation(codeOperation){
            var operation = '';
            switch (codeOperation) {
                case 'SOLD':
                    operation = 'Venta';
                    break;
                case 'CARGO_RECEPTION':
                    operation = 'Recepcion de Carga';
                    break;
                case 'SOLD_EXCHANGE_DATA':
                    operation = 'Cambio de Datos';
                    break;
                case 'SOLD_FLIGHT_CHANGE':
                    operation = 'Cambio de Vuelo';
                    break;
                case 'SOLD_CHANGE_OF_ROUTE':
                    operation = 'Cambio de Ruta';
                    break;
                case 'RETURN_OF_SALE':
                    operation = 'Devolucion';
                    break;
                case 'CHECKED':
                    operation = 'Check In';
                    break;
                case 'SOLD_EXTENSION_VALID_DATE':
                    operation = 'Ampliacion de Vigencia';
                    break;
                case 'LUGGAGE':
                    operation = 'Equipaje';
                    break;
                default:
                    operation = codeOperation;
            }
            return operation;
        }

        vm.getInvoices =  function(){
            var code = vm.code;
            vm.showPages = false;
            if(code == undefined || code==""){
                $timeout(function () {
                    vm.invoices = [];
                    vm.showPages = true;
                    vm.pages = paginationService.getPages();
                },100);
            }else {
                linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page,
                    size: $stateParams.size, code:vm.code})
            }
        }
    }

})();
